import _ from 'lodash';
import React from 'react';
import FormattedField from './formatted-field';
import currencyFormatter from 'currency-formatter';

class Currency extends FormattedField {
	get prefix () {
		return '$';
	}

	format (value) {
		const options = {
			code: 'USD'
		};

		return _.isEmpty(value) ? '' : currencyFormatter.format(value, options);
	}

	removeFormatting (value) {
		return window.parseInt(value.replace(/[^\d]+/, ''), 10);
	}
}

export default Currency;
